/* eslint-disable global-require */
var configureStore = process.env.NODE_ENV !== 'production' ? require('./configureStore.dev')["default"] : require('./configureStore.prod')["default"];
export default configureStore;


//////////////////
// WEBPACK FOOTER
// /Users/dmp/Code/catbirdproductions.ca/node_modules/@folklore/react-container/es/configureStore.js
// module id = null
// module chunks = 